<template>
  <report-section
    title="氧减统计"
    :reportModeType="reportDetailModel.reportModeType"
    :isHideBar="true"
    :odiIndex="reportDetailModel.odiIndex"
    
  >
    <template v-slot:content>
      <div class="oxygen-minus-stats">
        <div class="oxygen-minus-left">
          <div class="stat-item">
            <div class="stat-title">氧减指数(ODI): {{ reportDetailModel.odiIndex }}</div>
            <div class="ahi-bar-right" v-if="!isHideAHIBar">
              <div
                class="ahi-bar-right-triangle"
                :style="triangleStyleObject"
              ></div>
              <div class="ahi-bar-right-top">
                <div :style="greenBarStyleObject"></div>
                <div :style="yellowBarStyleObject"></div>
                <div :style="orangeBarStyleObject"></div>
                <div :style="redBarStyleObject"></div>
              </div>
              <div class="ahi-bar-right-bottom">
                <p class="ahi-bar-right-bottom-number">0</p>
                <p class="ahi-bar-right-bottom-text">正常</p>
                <p class="ahi-bar-right-bottom-number">{{ degreeArray[0] }}</p>
                <p class="ahi-bar-right-bottom-text">轻度</p>
                <p class="ahi-bar-right-bottom-number">{{ degreeArray[1] }}</p>
                <p class="ahi-bar-right-bottom-text">中度</p>
                <p class="ahi-bar-right-bottom-number">{{ degreeArray[2] }}</p>
                <p class="ahi-bar-right-bottom-text">重度</p>
                <p class="ahi-bar-right-bottom-number">∞</p>
              </div>
            </div>
          </div>
          <div class="stat-content-mt">
            <div class="stat-item">
            <div class="stat-content">氧减≥4% 发生{{ reportDetailModel.downTimesOver4Str }}次 指数{{ reportDetailModel.downIndexOver4Str }}</div>
          </div>
          
          <div class="stat-item">
            <div class="stat-content">氧减≥3% 发生{{ reportDetailModel.downTimesOver3Str }}次 指数{{ reportDetailModel.downIndexOver3Str }}</div>
          </div>
          
          <div class="stat-item">
            <div class="stat-content">最大氧减值: {{ reportDetailModel.TST  }}%</div>
          </div>
          
          <div class="stat-item">
            <div class="stat-content">最大氧减时间: {{ reportDetailModel.tstMaxDuration }}秒</div>
          </div>
          </div>
          
        </div>
        <section-oxygen-minus-event-table :reportDetailModel="reportDetailModel"></section-oxygen-minus-event-table>
          <section-oxygen-minus-time-table :reportDetailModel="reportDetailModel"></section-oxygen-minus-time-table>
      </div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-value-unit/key-value-unit-blood-oxygen-report.vue";
import SectionOxygenMinusEventTable from "@c/report-detail/single-blood-oxygen-report/new-section/section-oxygen-minus-event-table.vue";
import SectionOxygenMinusTimeTable from "@c/report-detail/single-blood-oxygen-report/new-section/section-oxygen-minus-time-table.vue";
export default {
  components: {
    ReportSection,
    KeyValueUnit,
    SectionOxygenMinusEventTable,
    SectionOxygenMinusTimeTable,
  },

  props: {
    reportDetailModel: Object,
  },

  data() {
    return {
      degreeStyleArray: [
        { width: 25, color: "#16d585" },
        { width: 25, color: "#EDF200" },
        { width: 25, color: "#F28300" },
        { width: 25, color: "#F2001D" },
      ],
    };
  },
  created() {
   
  },

  computed: {
    isHideAHIBar() {
      return (
        this.reportDetailModel.xyReportTemplateType ==
        SPO2_REPORT_TEMPLATE.河南省儿童医院耳鼻喉科
      );
    },
    degreeArray() {
      switch (this.reportDetailModel.reportModeType) {
        case DEVICE_MONITOR_MODE.儿童模式:
          return [1, 5, 10, 100];
        default:
          return [5, 15, 30, 100];
      }
    },
    triangleStyleObject() {
      if (this.reportDetailModel.odiIndex === "") {
        return {
          visibility: "hidden",
        };
      } else {
        for (let index = 0; index < this.degreeArray.length; index++) {
          const item = this.degreeArray[index];
          var value = Number.parseFloat(this.reportDetailModel.odiIndex);
          if (value > 100) {
            value = 100;
          }
          if (value <= item) {
            let width = 0;
            for (let i = 0; i < index; i++) {
              width += this.degreeStyleArray[i].width;
            }

            //超过的宽度
            const formerItem = index == 0 ? 0 : this.degreeArray[index - 1];
            const valueDifference = value - formerItem;
            const itemDifference = item - formerItem;
            const widthRate = valueDifference / itemDifference;

            width += this.degreeStyleArray[index].width * widthRate;

            return {
              marginLeft: `${width - 1.25}%`, //三角形顶点对齐
              borderTopColor: this.degreeStyleArray[index].color,
            };
          }

          continue;
        }
      }
    },
    greenBarStyleObject() {
      return {
        width: `${this.degreeStyleArray[0].width}%`,
        backgroundColor: this.degreeStyleArray[0].color,
      };
    },
    yellowBarStyleObject() {
      return {
        width: `${this.degreeStyleArray[1].width}%`,
        backgroundColor: this.degreeStyleArray[1].color,
      };
    },
    orangeBarStyleObject() {
      return {
        width: `${this.degreeStyleArray[2].width}%`,
        backgroundColor: this.degreeStyleArray[2].color,
      };
    },
    redBarStyleObject() {
      return {
        width: `${this.degreeStyleArray[3].width}%`,
        backgroundColor: this.degreeStyleArray[3].color,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.oxygen-minus-stats {
  display: flex;
  width: 100%;
}

.oxygen-minus-left {
  min-width: 250px;
  // padding-right: 20px;
}
.stat-content-mt{
  margin-top: 45px;
}

.stat-item {
  margin-bottom: 15px;
}

.stat-title {
  font-size: 18px;
  // font-weight: 600;
  color: #000;
  margin-bottom: 10px;
}

.stat-content {
  font-size: 16px;
  color: #000;
  line-height: 1.5;
}

/* 从report-section.vue复制过来的指示条样式 */
.ahi-bar-right {
  width: rem(220);
  height: rem(32);
  margin-top: 5px;
  margin-bottom: 10px;

  &-triangle {
    display: inline-block;
    width: 0;
    height: 0;
    border-top: rem(10) solid;
    border-left: rem(5) solid transparent;
    border-right: rem(5) solid transparent;
  }

  &-top {
    display: flex;
    width: rem(220);
    height: rem(5);

    div {
      height: 100%;
    }
  }

  &-bottom {
    color: #333333;
    font-size: rem(12);
    width: rem(223);

    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: rem(3);

    &-number {
      color: #999999;
      font-size: rem(12);
    }

    &-text {
      color: #333333;
      font-size: rem(12);
      font-weight: bold;
    }
  }
}

/* 保留原来的表格样式，以便您后续添加右侧表格 */
.table {
  border: 1px solid #707070;

  &-row {
    display: flex;
    justify-content: space-evenly;

    &-item {
      color: black;
      font-size: 16px;
      // font-weight: 400;
      border: 1px solid #707070;
      width: 250px;
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;

      &-bold {
        // font-weight: 600;
      }
    }
  }
}
</style>
